<div [matTooltip]="tooltip" [ngClass]="type" class="status flex flex-col items-center justify-start">
  <span class="flex flex-row items-center justify-start gap-4">
    <app-icon class="{{class}}" [name]="'ellipse'" size="16px"></app-icon>

    <span *ngIf="name" [ngClass]="{ bold: bold }" class="name {{class}}">{{ name }}</span>
  </span>
</div>
